import { render, staticRenderFns } from "./UvView.vue?vue&type=template&id=7769001c&scoped=true"
import script from "./UvView.vue?vue&type=script&lang=js"
export * from "./UvView.vue?vue&type=script&lang=js"
import style0 from "./UvView.vue?vue&type=style&index=0&id=7769001c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7769001c",
  null
  
)

export default component.exports